
import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { Image } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export const LogoSettings = () => {
  const { toast } = useToast();
  const { currentUser } = useAuth();
  const [logoName, setLogoName] = useState("MRS IA");
  const [logoUrl, setLogoUrl] = useState("");
  const [tempLogoName, setTempLogoName] = useState(logoName);
  const [tempLogoUrl, setTempLogoUrl] = useState(logoUrl);

  useEffect(() => {
    fetchLogoSettings();
  }, []);

  const fetchLogoSettings = async () => {
    try {
      console.log("Iniciando busca das configurações do logo...");
      const { data, error } = await supabase
        .from('logo_settings')
        .select('*')
        .maybeSingle();

      if (error) {
        console.error('Erro detalhado ao buscar configurações do logo:', error);
        throw error;
      }

      console.log("Dados recebidos do logo_settings:", data);

      if (data) {
        setLogoName(data.name);
        setLogoUrl(data.url || "");
        setTempLogoName(data.name);
        setTempLogoUrl(data.url || "");
      } else {
        console.log("Nenhuma configuração de logo encontrada, usando valores padrão");
        // Se não existir configuração, criar uma nova
        const { error: insertError } = await supabase
          .from('logo_settings')
          .insert([{
            name: logoName,
            url: "",
            created_at: new Date(),
            updated_at: new Date()
          }]);

        if (insertError) {
          console.error('Erro ao criar configurações iniciais do logo:', insertError);
          throw insertError;
        }
      }
    } catch (error) {
      console.error('Erro ao buscar configurações do logo:', error);
      toast({
        variant: "destructive",
        title: "Erro ao carregar",
        description: "Não foi possível carregar as configurações da logo.",
      });
    }
  };

  const handleSaveLogo = async () => {
    try {
      console.log("Iniciando salvamento das configurações do logo...");
      const { data, error } = await supabase
        .from('logo_settings')
        .upsert({
          name: tempLogoName,
          url: tempLogoUrl,
          updated_at: new Date().toISOString()
        })
        .select()
        .single();

      if (error) {
        console.error('Erro detalhado ao salvar configurações do logo:', error);
        throw error;
      }

      console.log("Configurações do logo salvas com sucesso:", data);

      setLogoName(tempLogoName);
      setLogoUrl(tempLogoUrl);
      
      toast({
        title: "Logo atualizada",
        description: "As configurações da logo foram salvas com sucesso!",
      });
    } catch (error) {
      console.error('Erro ao salvar configurações do logo:', error);
      toast({
        variant: "destructive",
        title: "Erro ao salvar",
        description: "Ocorreu um erro ao salvar as configurações da logo.",
      });
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {currentUser?.type === 'super_admin' 
            ? "Personalização da Logo - Todas as Empresas"
            : "Personalização da Logo da Empresa"}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="logoName">Nome da Logo</Label>
          <Input
            id="logoName"
            value={tempLogoName}
            onChange={(e) => setTempLogoName(e.target.value)}
            placeholder="Digite o nome da logo"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="logoUrl">URL da Imagem da Logo</Label>
          <Input
            id="logoUrl"
            value={tempLogoUrl}
            onChange={(e) => setTempLogoUrl(e.target.value)}
            placeholder="Cole o link da imagem da logo"
          />
        </div>

        {tempLogoUrl && (
          <div className="mt-4">
            <Label>Preview da Logo</Label>
            <div className="mt-2 p-2 border rounded-lg w-16 h-16 flex items-center justify-center">
              <img
                src={tempLogoUrl}
                alt="Logo Preview"
                className="max-w-full max-h-full object-contain"
                onError={(e) => {
                  e.currentTarget.src = "";
                  toast({
                    title: "Erro ao carregar imagem",
                    description: "Verifique se a URL da imagem está correta",
                    variant: "destructive",
                  });
                }}
              />
            </div>
          </div>
        )}

        <Button onClick={handleSaveLogo} className="w-full">
          <Image className="mr-2 h-4 w-4" />
          Salvar Logo
        </Button>
      </CardContent>
    </Card>
  );
};
